exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changed[data-v-38e6eaef]{font-weight:700;animation:blinker-data-v-38e6eaef 1s linear infinite}@keyframes blinker-data-v-38e6eaef{0%{opacity:0}50%{opacity:.5}to{opacity:1}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38e6eaef","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard/WatchList.vue
// module id = 152
// module chunks = 0